import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export function formatRelativeTime(dateString) {
  if (!dateString) return '';

  const date = dayjs(dateString);
  if (!date.isValid()) return '';

  return date.fromNow();
}

export function groupSessionsByDate(sessions) {
  const now = dayjs();
  const todayStart = now.startOf('day');
  const yesterdayStart = todayStart.subtract(1, 'day');
  const weekAgoStart = todayStart.subtract(7, 'day');

  const groups = {
    Today: [],
    Yesterday: [],
    'Previous 7 Days': [],
    Older: [],
  };

  for (const session of sessions) {
    const d = dayjs(session.UPDATED_AT);

    if (!d.isValid()) {
      groups.Older.push(session);
      continue;
    }

    if (d.isAfter(todayStart) || d.isSame(todayStart)) {
      groups.Today.push(session);
    } else if (d.isAfter(yesterdayStart) || d.isSame(yesterdayStart)) {
      groups.Yesterday.push(session);
    } else if (d.isAfter(weekAgoStart) || d.isSame(weekAgoStart)) {
      groups['Previous 7 Days'].push(session);
    } else {
      groups.Older.push(session);
    }
  }

  return groups;
}
